// extracted by mini-css-extract-plugin
export var alertIcon = "_sj-0";